import { Notifications as NotificationsAxios } from "../../../../generated/clients/notifications/Notifications";
import { Notification } from "../../../../generated/clients/notifications/data-contracts";
import { getEnvValue } from "../../utils/env.helper";

export type GetAllNotificationsResponse = {
  notifications?: Notification[];
  hasNextPage?: boolean;
  nextPage?: number | null;
};

// TODO: Notification service is temporarily disabled.
// To re-enable, set this to true and the real API calls will be used again.
const NOTIFICATION_SERVICE_ENABLED = false;

export class NotificationServiceClient {
  private client: NotificationsAxios | null = null;

  constructor() {
    if (NOTIFICATION_SERVICE_ENABLED) {
      const baseURL = getEnvValue("NOTIFICATION_SERVICE_API_PATH");
      this.client = new NotificationsAxios({
        baseURL,
      });
    }
  }

  getAllNotifications = async (
    bearer: string,
    page: number = 1
  ): Promise<GetAllNotificationsResponse> => {
    if (!this.client) {
      return { notifications: [], hasNextPage: false, nextPage: null };
    }

    let response = await this.client.getAll(
      { page, unread: true },
      { headers: { Authorization: `Bearer ${bearer}` } }
    );

    const { docs, nextPage, hasNextPage } = response.data;
    const getAllNotificationsResponse: GetAllNotificationsResponse = {
      notifications: docs,
      nextPage: nextPage,
      hasNextPage,
    };
    return getAllNotificationsResponse;
  };

  markNotificationAsRead = async (bearer: string, id: string) => {
    if (!this.client) return;

    await this.client.markOneAsRead(id, {
      headers: { Authorization: `Bearer ${bearer}` },
    });
  };

  markAllNotificationsAsRead = async (bearer: string) => {
    if (!this.client) return;

    await this.client.markAllAsRead({
      headers: { Authorization: `Bearer ${bearer}` },
    });
  };
}
